/*
	Trigger lightbox modal:
	<[a|button] class="jsLightboxInit"
		data-type="[ajax|video|inline|form|img]"
		data-src="[URL|ID]" // see below
		data-popup="[true|false]" // truthy or falsey
		data-identifier="[someString]" // Optional; styling hook for unique lightboxes
		>
		Trigger Lightbox
	</[a|button]>

	data-src should be a URL for data-types of `ajax`, `video`, or `img`
	data-src should be an ID (no # char) for data-types of `inline` or `form`

	The styling hook can be used in a CSS selector as follows:

	.lightbox[data-identifier="someString"] { ... }
*/

// import anime from "animejs";
import Tab from "./Tab";
import Cookie from "./Cookie";
import {parse} from '../../helpers/video'

import axios from 'axios'

export default class Lightbox
{
	constructor()
	{
		var number = 1;
		var elementWrapper = document.querySelector('body');
		// Single lightbox at bottom of page
		var _lightbox = document.querySelector(".jsLightbox[data-number='1']");
		this.skeleton = "";

		// Init lightbox if it exists on page.
		if (_lightbox)
		{
			_lightbox.classList.add('cloned');
			this.skeleton = _lightbox.outerHTML;
			_lightbox.classList.remove('cloned');

			this.init(number, elementWrapper);
		}
	}

	// Open Lightbox
	openLightbox(_lightbox, src, type, caption, title = '', number)
	{
		// Init vars
		let html = "";
		var element = document.createElement("div");
		var _lightboxMedia = _lightbox.querySelector(".jsLightboxMedia");
		var data_type = "html";

		// What type of lightbox is it?
		switch (type)
		{
			// AJAX
			case "ajax":
				// Fetch URL (provided in `data-src`)
				axios.get(src).then((response) =>
				{
					// Inject response into lightbox
					_lightboxMedia.innerHTML = `<div class="lightbox-content">${response.data}</div>`
				})
			break;

			case "video":
				// Determine if URL is for YouTube, Vimeo, or Other
				const video = parse(src)
				data_type = "video";

				switch (video.type)
				{
					case 'vimeo':
						html = `
						<div class="responsive-embed">
							<iframe title="${title}" style="background-color: black;" src="https://player.vimeo.com/video/${video.id}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
						</div>`;
					break;

					case 'youtube':
						html = `
						<div class="responsive-embed">
							<iframe title="${title}" style="background-color: black;" src="https://www.youtube.com/embed/${video.id}?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
						</div>`;
					break;

					default:
						html = `
						<div class="responsive-embed">
							<iframe title="${title}" src="${src}" frameborder="0" allow="autoplay; encrypted-media" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
						</div>`;
					break;
				} // switch (video.type)
			break;

			case "inline":
				const inline = document.getElementById(src).innerHTML;
				html = `<div class="lightbox-content inline">${inline}</div>`;
			break;

			case "form":
				data_type = "form";
				const form_lightbox = document.getElementById(src);
				element.appendChild(form_lightbox.firstElementChild);
			break;

			case "img":
				data_type = "image";
				html = `
				<div class="image image--lightbox">
					<img src="${src}" alt="${caption}" class="image__box" />
					<div class="image__caption box box--padding">
						<span class="image__txt">${caption}</span>
					</div>
				</div>`;
		} // switch (type)

		_lightbox.setAttribute('data-type', data_type);

		if ( type == "form" )
		{
			_lightboxMedia.appendChild(element);
		}
		else
		{
			_lightboxMedia.innerHTML = '<div>' + html + '</div>';
		}

		var _lightboxInit = _lightboxMedia.querySelectorAll(".jsLightboxInit");
		if (_lightboxInit)
		{
			var element = document.createElement("div");
			element.innerHTML = this.skeleton;
			document.querySelector('body').appendChild(element);
			var temp = document.querySelector('.jsLightbox.cloned');
			var newNumber = Number(number) + 1;
			temp.setAttribute('data-number', newNumber);
			temp.classList.remove('cloned');

			_lightbox = document.querySelector(".jsLightbox[data-number='" + newNumber + "']");
			this.init(newNumber, _lightboxMedia);
		}

		/*
			// Single lightbox at bottom of page
			_lightbox = document.querySelector(".jsLightbox");
			// "Content" of lightbox? Why's it called "media"? Whatever.
			_lightboxMedia = document.querySelector(".jsLightboxMedia");
			// _lightboxClose = document.querySelectorAll(".jsLightboxClose");
			_lightboxClose = '';

			// Store lightbox init buttons
			_lightboxInit = document.querySelectorAll(".jsLightboxInit");
		*/

	}

	// Close lightbbox
	closeLightbox(_lightbox)
	{
		// Remove `active` class
		_lightbox.classList.remove("active");
		_lightbox.setAttribute('data-type', '');

		// Remove unique identifier
		delete _lightbox.dataset.identifier;

		var _lightboxMedia = _lightbox.querySelector(".jsLightboxMedia");

		// Not sure what this part is for.
		var element = _lightboxMedia.getElementsByClassName("element")[0];
		if ( element )
		{
			var src_element = document.getElementById(element.dataset.src);
			if ( src_element )
			{
				src_element.appendChild(element);
			}
		}
		// Empty out lightbox for future use.
		_lightboxMedia.innerHTML = "";
	}

	// Init lightbox
	init(number = 1, elementWrapper)
	{

		var _lightbox = document.querySelector(".jsLightbox[data-number='" + number + "']");
		// "Content" of lightbox? Why's it called "media"? Whatever.
		var _lightboxMedia = _lightbox.querySelector(".jsLightboxMedia");
		// _lightboxClose = document.querySelectorAll(".jsLightboxClose");
		var _lightboxClose = '';
		// Store lightbox init buttons
		var _lightboxInit = elementWrapper.querySelectorAll(".jsLightboxInit");

		// Loop over all buttons that init lightbox (`.jsLightboxInit`)
		for (let i = 0; i < _lightboxInit.length; i++)
		{
			// Get current button
			const el = _lightboxInit[i];

			// Set caption to `data-credit` attr
			let caption = el.dataset.credit || '';

			// Check if `data-popup` attr is set
			var popup = 0;
			if ( el.hasAttribute('data-popup') )
			{
				popup = el.dataset.popup;
			}

			// If there is a popup, open it automatically??
			if ( popup == 1 )
			{
				// var viewedPopup = Cookie.getCookie("viewedPopup");
				// if ( viewedPopup == "" )
				// {
				// if ( !sessionStorage.alreadyClicked )
				// {

				// Mark lightbox active
				_lightbox.classList.add("active");

				// Add unique identifier to LB (if provided)
				if (el.dataset.identifier)
				{
					_lightbox.dataset.identifier = el.dataset.identifier;
				}

				// Open lightbox
				this.openLightbox(_lightbox, el.dataset.src, el.dataset.type, caption, el.dataset.title, number);

				// Cookie.setCookie("viewedPopup", 1, 30);
				// sessionStorage.alreadyClicked = "true";
				// }
			}
			// If no popup
			else
			{
				// Listen for clicks
				el.addEventListener("click", (event) =>
				{
					// Prevent default click action
					event.preventDefault();

					// Mark lightbox active
					_lightbox.classList.add("active");

					// Add unique identifier to LB (if provided)
					if (el.dataset.identifier)
					{
						_lightbox.dataset.identifier = el.dataset.identifier;
					}

					// Open lightbox
					this.openLightbox(_lightbox, el.dataset.src, el.dataset.type, caption, el.dataset.title, number);
				});
			}
		} // END loop over all lightbox trigger buttons

		// Add event listeners to close buttons
		_lightboxClose = _lightbox.querySelectorAll(".jsLightboxClose");
		for (let i = 0; i < _lightboxClose.length; i++)
		{
			const el = _lightboxClose[i];

			el.addEventListener("click", (event) =>
			{
				event.preventDefault();
				this.closeLightbox(_lightbox);
			});
		}
	}
}
